export const RO = {
    translations: {
        notifications: 'Notificări',
        markAllAsRead: 'Marcheaza totul ca fiind citit',
        poweredBy: 'Cu sprijinul',
        settings: 'Setări',
        noNewNotification: 'Nimic nou de văzut aici încă',
    },
    lang: 'ro',
};
//# sourceMappingURL=ro.js.map